import { render, staticRenderFns } from "./majorDetail.vue?vue&type=template&id=54b99247&scoped=true&"
import script from "./majorDetail.vue?vue&type=script&lang=js&"
export * from "./majorDetail.vue?vue&type=script&lang=js&"
import style0 from "./majorDetail.vue?vue&type=style&index=0&id=54b99247&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b99247",
  null
  
)

export default component.exports